import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { CommonModule } from '@angular/common';
import { GrantDetailsService } from './grant-details.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { valueMapping } from './data/mapping';
import { MitiPopupComponent } from './components/miti-popup/miti-popup.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-miti-details',
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    imports: [HeaderComponent, FooterComponent, CommonModule, TranslateModule],
    templateUrl: './miti-details.component.html',
    styleUrl: './miti-details.component.scss',
})
export class MitiDetailsComponent implements OnInit {
    selectedLanguage: any;
    miti: any = null;
    selectedTab: string = 'objectives';
    content = '';
    selectedHeading: string = 'GRANTS.OBJECTIVES_LABEL';
    imgs: string[] | null = null;

    sideNav = [
        {
            slug: 'objectives',
            title: 'GRANTS.OBJECTIVES',
            label: 'GRANTS.OBJECTIVES_LABEL',
        },
        {
            slug: 'sector',
            title: 'GRANTS.SECTOR',
            label: 'GRANTS.SECTOR_LABEL',
        },
        {
            slug: 'eligibility',
            title: 'GRANTS.ELIGIBILITY',
            label: 'GRANTS.ELIGIBILITY',
        },
        {
            slug: 'scope-of-funding',
            title: 'GRANTS.SCOPE_OF_FUNDING',
            label: 'GRANTS.SCOPE_OF_FUNDING',
        },
        {
            slug: 'funding-value',
            title: 'GRANTS.FUNDING_VALUE',
            label: 'GRANTS.FUNDING_VALUE',
        },
    ];

    constructor(
        private mitiService: GrantDetailsService,
        private _route: ActivatedRoute,
        private _router: Router,
        private dialog: MatDialog
    ) {}

    ngOnInit(): void {
        this.selectedLanguage = localStorage.getItem('language');
        this._route.paramMap.subscribe((params) => {
            const slug = params.get('slug');
            this.mitiService.getMitiData(slug).subscribe((data) => {
                if (data?.product) {
                    this.miti = data?.product;
                    this.imgs = data?.images;
                    this.content =
                        this.selectedLanguage == 'en'
                            ? this.miti.objective
                            : this.miti.objectiveBm;
                } else {
                    this._router.navigate(['/grants']);
                }
            });
        });
    }

    switchedLanguage(data: any) {
        this.selectedLanguage = data;
        if (this?.miti) {
            this.setTab({
                slug: this.selectedTab,
                label: this.selectedHeading,
            });
        }
    }

    switchLanguageHandler(data: any) {
        this.selectedLanguage = data;
    }

    setTab(nav: any) {
        const { slug } = nav;
        let key = 'objectives';

        switch (slug) {
            case 'sector':
                key = 'sector';
                break;
            case 'eligibility':
                this.selectedLanguage === 'en'
                    ? (key = 'eligibilityDesc')
                    : (key = 'eligibilityDescBm');
                break;
            case 'funding-value':
                this.selectedLanguage === 'en'
                    ? (key = 'fundvalue')
                    : (key = 'fundValueBm');
                break;
            case 'scope-of-funding':
                this.selectedLanguage === 'en'
                    ? (key = 'scopeFund')
                    : (key = 'scopeFundBm');
                break;

            default:
                this.selectedLanguage === 'en'
                    ? (key = 'objective')
                    : (key = 'objectiveBm');
        }
        const data = this.miti[key];
        this.content = data;

        // if (slug === 'eligibility' || slug === 'scope-of-funding') {
        //     this.content = this.generateHtml(data);
        // } else

        if (slug === 'sector') {
            this.content = this.generateSectorTable(valueMapping.sectors, data);
        } else if (slug === 'funding-value') {
            this.content = this.generateTable(valueMapping.fundValues, data);
        }
        this.selectedTab = nav.slug;
        this.selectedHeading = nav.label;
    }

    generateHtml(data: string): string {
        const listItems = data.trim();
        if (!listItems) return '';

        const items = listItems.match(/\d+\.\s[^.]+(?:\.(?!\s\d+\.)|[^.])*/g);

        if (items) {
            const htmlList = items
                .map((item) => `<li>${item.trim()}</li>`)
                .join('');
            return `<ol>${htmlList}</ol>`;
        }
        return '';
    }

    generateSectorTable(
        sectors: { code: string; en: string; bm: string }[],
        input: string
    ): string {
        const inputCodes = input.split('|').filter((code) => code);
        const matchedSectors = sectors.filter((sector) =>
            inputCodes.includes(sector.code)
        );
        let tableHtml =
            '<table class="sector" border="1" style="width: 100%; border-collapse: collapse;">';
        tableHtml += '<tbody>';
        for (let i = 0; i < matchedSectors.length; i += 2) {
            const sector1 = matchedSectors[i];
            const sector2 = matchedSectors[i + 1];
            const desc1 = sector1
                ? `${this.selectedLanguage === 'en' ? sector1.en : sector1.bm}`
                : '';
            const desc2 = sector2
                ? `${this.selectedLanguage === 'en' ? sector2.en : sector2.bm}`
                : '';
            tableHtml += `<tr><td>${desc1}</td><td>${desc2}</td></tr>`;
        }
        tableHtml += '</tbody></table>';
        return tableHtml;
    }

    generateTable(
        sectors: { code: string; en: string; bm: string }[],
        input: string
    ): string {
        const inputCodes = input.split('|').filter((code) => code);

        const matchedSectors = sectors.filter((sector) =>
            inputCodes.includes(sector.code)
        );

        const minToMaxLabel =
            this.selectedLanguage === 'en'
                ? 'Min to Max'
                : 'Minimum ke Maksimum';
        const fundingAmountLabel =
            this.selectedLanguage === 'en'
                ? 'Funding Amount'
                : 'Jumlah Pembiayaan';
        const valLabel = this.selectedLanguage === 'en' ? 'Value' : 'Nilai';

        let tableHtml =
            '<table border="1" style="width: 100%; border-collapse: collapse;">';

        tableHtml += `
            <thead>
                <tr>
                    <th style="padding: 8px; text-align: left;">${valLabel}</th>
                    <th style="padding: 8px; text-align: left;">${fundingAmountLabel}</th>
                </tr>
            </thead>
        `;

        tableHtml += '<tbody>';
        for (let i = 0; i < matchedSectors.length; i++) {
            const sector = matchedSectors[i];

            let description = sector
                ? `${this.selectedLanguage === 'en' ? sector.en : sector.bm}`
                : '';

            description = this.formatFundingValue(description);

            tableHtml += `
                <tr>
                    <td style="padding: 8px; border: 1px solid #ccc;">${minToMaxLabel}</td>
                    <td style="padding: 8px; border: 1px solid #ccc;">${description}</td>
                </tr>
            `;
        }
        tableHtml += '</tbody></table>';

        return tableHtml;
    }

    formatFundingValue(value: string): string {
        if (!value) return '';

        if (value.includes('-')) {
            const parts = value.split('-').map((v) => v.trim());
            return `RM ${parts[0]} - RM ${parts[1]}`;
        }

        if (value.includes('and above')) {
            const parts = value.split(' ');
            return `RM ${parts[0]} ${parts.slice(1).join(' ')}`;
        }

        return `RM ${value}`;
    }

    openDialog() {
        const isMobile = window.innerWidth <= 768;
        this.dialog.open(MitiPopupComponent, {
            width: isMobile ? '100%' : '820px',
            maxWidth: isMobile && '95vw',
            height: isMobile ? '95%' : '440px',
            panelClass: 'miti-popup',
            data: this.miti,
        });
    }
}
